import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer data-testid="footer-container" className="bg-[#0A111E] text-slate-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Logo inverted />
          <p className="mt-5 text-sm leading-relaxed text-slate-400">
            Professioneller Gebäudeunterhalt und Reinigung aus Mühlau AG — präzise, zuverlässig und mit Schweizer Qualitätsanspruch. Im Einsatz in den Kantonen Aargau, Luzern, Zürich und Zug.
          </p>
        </div>
        <div>
          <h4 className="font-tech text-xs uppercase tracking-[0.25em] text-[#5882C7] mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors duration-200">Startseite</Link></li>
            <li><Link to="/leistungen" className="hover:text-white transition-colors duration-200">Leistungen</Link></li>
            <li><Link to="/referenzen" className="hover:text-white transition-colors duration-200">Referenzen</Link></li>
            <li><Link to="/kontakt" className="hover:text-white transition-colors duration-200">Kontakt & Offerte</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-tech text-xs uppercase tracking-[0.25em] text-[#5882C7] mb-5">Leistungen</h4>
          <ul className="space-y-3 text-sm">
            <li>Gebäudeunterhalt</li>
            <li>Unterhaltsreinigung</li>
            <li>Winterservice</li>
            <li>Spezialreinigung</li>
            <li>Entsorgung</li>
            <li>Gartenarbeiten</li>
          </ul>
        </div>
        <div data-testid="footer-company-info">
          <h4 className="font-tech text-xs uppercase tracking-[0.25em] text-[#5882C7] mb-5">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#5882C7]" /><span>HRG Service GmbH<br />Rüstenschwilerstrasse 2<br />5642 Mühlau, Schweiz</span></li>
            <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-[#5882C7]" /><a href="tel:+41782238087" className="hover:text-white transition-colors duration-200">+41 78 223 80 87</a></li>
            <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-[#5882C7]" /><a href="mailto:info@hrgservice.ch" className="hover:text-white transition-colors duration-200">info@hrgservice.ch</a></li>
            <li className="flex items-center gap-3"><Clock className="h-4 w-4 text-[#5882C7]" /><span>Mo–Fr 07:00–18:00, Sa nach Vereinbarung</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} HRG Service GmbH, Mühlau AG. Alle Rechte vorbehalten.</p>
          <a
            data-testid="footer-emergency-call"
            href="tel:+41765137667"
            className="inline-flex items-center gap-2 rounded-full text-xs font-semibold text-white bg-[#3B62A5] px-4 py-2 hover:bg-[#2A477A] transition-colors duration-200"
          >
            <Phone className="h-3.5 w-3.5" /> 24/7 Notfallnummer: +41 76 513 76 67
          </a>
        </div>
        <div data-testid="impressum" className="border-t border-white/10">
          <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16 py-5">
            <p className="text-xs text-slate-500 leading-relaxed">
              <span className="font-semibold text-slate-400 uppercase tracking-wider">Impressum:</span> HRG Service GmbH, Rüstenschwilerstrasse 2, 5642 Mühlau — Vertretungsberechtigt: Vilma Pasuli
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
